import styled from 'styled-components';

import { Flex, Container, Text } from '@olxbr/ds-web';

export const Wrapper = styled(Flex)`
  display: flex;
  justify-content: center;
  width: 200px;
  margin: 16px 0 24px 0;
`;

export const ListItems = styled.ul`
  z-index: 1003;
  cursor: default;
  position: absolute;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 22%) 0px 16px 24px 0px;
  margin-top: 50px;
  padding-top: 16px;
  overflow: hidden;
  width: ${({ width }) => (width ? `${width}` : '100%')};
`;

export const Item = styled.li`
  width: 100%;
  font-size: 16px;
  line-height: 1.5;
  color: #545454;
  padding: 8px 15px;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  user-select: none;
  box-sizing: border-box;
  text-align: center;

  &:hover {
    background: #f6f6f6;
    color: #6e0ad6;
  }
`;

export const Header = styled(Container)`
  width: 100%;
  height: 50px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Text.BodyMedium)`
  text-align: center;
`;
